// extracted by mini-css-extract-plugin
module.exports = {"home":"ProjectListPage-styles-module--home--OLS4t"};